module.exports = __webpack_public_path__ + "officialStatic/img/feedbackBg.518b869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/feedbackBg.png
// module id = roih
// module chunks = 0